import METRICS_ENUM from "@/enums/gmbMetrics.enum.js";
import { GMBBuilderDirector } from "./make-gmb-data/gmb-builder-director";
import { GMBAddressesFacadeBase } from "./gmb-addresses-facade-base";
import { store } from "@/store/store";
import { MakeGMBCharts } from "./make-gmb-charts/make-gmb-charts";

export class GMBAddressesFacade extends GMBAddressesFacadeBase {
  async _setGmbBuilderDirector(gmbDataEnum, downloadFileExtension = null) {
    const builderDirector = new GMBBuilderDirector();
    await builderDirector.createGMBDataOld(
      gmbDataEnum,
      this.gmbPayloadConfig,
      downloadFileExtension
    );
    this.gmbData = builderDirector.returnGMBDataOld();
  }

  async _setGmbPayloadConfig() {
    const selectedGoogleImportedAddressesIds = store.state.facilities.selectedFacilities.map(
      facility => facility.gmb_address_id
    );

    this.gmbPayloadConfig = this.isCompared
      ? {
          dateFrom: this.periodObj.dateFrom,
          dateTo: this.periodObj.dateTo,
          compareDateFrom: this.periodObj.compareDateFrom,
          compareDateTo: this.periodObj.compareDateTo,
          googleImportedAddressesIds: selectedGoogleImportedAddressesIds,
          metrics: Object.values(METRICS_ENUM),
          group: this.periodObj.group
        }
      : {
          dateFrom: this.periodObj.dateFrom,
          dateTo: this.periodObj.dateTo,
          googleImportedAddressesIds: selectedGoogleImportedAddressesIds,
          metrics: Object.values(METRICS_ENUM),
          group: this.periodObj.group
        };
  }

  _setGMBCharts() {
    const gmbCharts = new MakeGMBCharts();
    gmbCharts.makeCharts({ gmbData: this.gmbData });
    this.charts = gmbCharts.returnCharts();
  }
}
